import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box } from "@mui/material"
import React, { useState } from "react"
import CustomerTable from "../../Table/CustomerTable"
import { StyledTab } from "./Atom"

function CustomerManagementTabs(props: any) {
  const {
    handleGroupFetchAssigned,
    handleGroupFetchUnAssigned,
    groupInfoHandler,
    metricDetailsHandler,
    groupDetailsHandler,
  } = props

  const [valueTab, setValueTab] = useState("1")

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValueTab: string,
  ) => {
    setValueTab(newValueTab)
  }

  return (
    <Box
      sx={{
        "& .MuiTabPanel-root": {
          padding: "0px",
        },
      }}
    >
      <TabContext value={valueTab}>
        <Box
          sx={{
            "& .css-17xr6ms-MuiTabs-root": {
              marginLeft: "24px",
            },
          }}
        >
          <TabList
            aria-label="Tabs"
            onChange={handleChangeTab}
            TabIndicatorProps={{
              sx: { maxWidth: "34px", height: "4px" },
            }}
          >
            <StyledTab
              label="Assigned Groups"
              value="1"
              disableRipple
              onClick={() => {
                handleGroupFetchAssigned("assigned")
              }}
            />
            <StyledTab
              label="Unassigned Groups"
              value="2"
              disableRipple
              onClick={() => {
                handleGroupFetchUnAssigned("unassigned")
              }}
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          <CustomerTable
            groupInfoHandler={groupInfoHandler}
            metricDetailsHandler={metricDetailsHandler}
            groupDetailsHandler={groupDetailsHandler}
          />
        </TabPanel>
        <TabPanel value="2">
          <CustomerTable
            groupInfoHandler={groupInfoHandler}
            metricDetailsHandler={metricDetailsHandler}
            groupDetailsHandler={groupDetailsHandler}
          />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
export default CustomerManagementTabs
